import React, { FC, useState } from 'react'
import ChevronDownIcon from '../../../components/common/chevron_down_icon'
import { FaqItem as FaqItemType } from '../../../clients/kyousou_api_client'

type FaqBlockProps = {
  category: string
  faqs: FaqItemType[]
}

const FaqBlock: FC<FaqBlockProps> = (props) => {
  return (
    <div className="mb-8 bg-white rounded-lg border border-main-lightgray p-6 sm:p-8">
      <h2 className="text-lg sm:text-xl font-bold mb-6">{props.category}</h2>
      <div>
        {props.faqs.map((item, index) => {
          return (
            <FaqItem
              key={`faq-item-${String(index)}`}
              index={index}
              {...item}
            />
          )
        })}
      </div>
    </div>
  )
}

export default FaqBlock

const FaqItem: FC<FaqItemType & { index: number }> = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="rounded-lg bg-main-lightgray p-4 mb-4">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-base sm:text-lg">{props.question}</p>
        <div
          className="duration-200 transition-transform flex-shrink-0 ml-4"
          style={
            isOpen
              ? { transform: 'rotate(180deg)' }
              : { transform: 'rotate(0deg)' }
          }
        >
          <ChevronDownIcon className="h-5 w-5 text-main-darkgray" />
        </div>
      </div>
      <div
        className="overflow-hidden duration-200 transition-all"
        style={
          isOpen
            ? { maxHeight: '500px', paddingTop: '16px', paddingBottom: '0px' }
            : { maxHeight: '0px', paddingTop: '0px', paddingBottom: '0px' }
        }
      >
        <p className="whitespace-pre-wrap">{props.answer}</p>
      </div>
    </div>
  )
}
